/* ═══════════════════════════════════════════════════════════
   OcuTrap · gold-redesign shell behavior
   Mobile menu toggle for the redesign header (IDs ocuHamburger /
   ocuMobileMenu). Header/footer are real Liquid sections (not
   JS-injected). Cart uses the existing cart drawer ([data-open-cart]);
   page-specific behaviors live in their own section assets.
   ═══════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  function wireMenu() {
    var btn = document.getElementById("ocuHamburger");
    var menu = document.getElementById("ocuMobileMenu");
    if (!btn || !menu) return;

    function setMenuState(open, returnFocus) {
      menu.classList.toggle("open", open);
      menu.setAttribute("aria-hidden", open ? "false" : "true");
      menu.inert = !open;
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      btn.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      if (!open && returnFocus) btn.focus();
    }

    setMenuState(false, false);

    btn.addEventListener("click", function () {
      setMenuState(!menu.classList.contains("open"), false);
    });
    menu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        // Native anchor scrolling measures the page after this handler. An
        // animated menu collapse keeps moving that destination underneath it.
        // Finish the collapse now; toggle/Escape retain their usual transition.
        var transition = menu.style.transition;
        menu.style.transition = "none";
        setMenuState(false, false);
        menu.getBoundingClientRect();
        menu.style.transition = transition;
      });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && menu.classList.contains("open")) {
        setMenuState(false, true);
      }
    });

    var desktopQuery = window.matchMedia("(min-width: 901px)");
    desktopQuery.addEventListener("change", function (event) {
      if (event.matches) setMenuState(false, false);
    });
  }

  // Shopify Inbox mounts as a <shopify-chat> element, which the selector
  // missed, so the footer clearance rules never applied and the bubble could
  // sit on the bottom-row links (REQ-AUDIT-0930-01). The app loads late, so
  // watch for it for a bounded 15s instead of two fixed checks.
  function wireChatClearance() {
    var selector = "shopify-chat, #shopify-chat, [id^='shopify-chat'], #ShopifyChat, .shopify-chat-button, #ocuChat";
    function markChat() {
      if (!document.querySelector(selector)) return false;
      document.body.classList.add("has-ocu-chat");
      return true;
    }
    if (markChat()) return;
    if (typeof MutationObserver !== "function") { setTimeout(markChat, 2500); return; }
    var observer = new MutationObserver(function () { if (markChat()) observer.disconnect(); });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  // Keep the Inbox launcher off mobile pricing/stock copy. An inline contact
  // link stays available; the launcher returns once this decision area leaves.
  var homeChatObserver;
  function wireHomeChatClearance() {
    if (homeChatObserver) homeChatObserver.disconnect();
    document.body.classList.remove("h25-buying-visible");
    var copy = document.querySelector(".h25-hero__copy");
    if (!copy || typeof IntersectionObserver !== "function") return;
    homeChatObserver = new IntersectionObserver(function (entries) {
      document.body.classList.toggle("h25-buying-visible", entries[0].isIntersecting);
    }, { rootMargin: "-68px 0px 0px 0px" });
    homeChatObserver.observe(copy);
  }

  document.addEventListener("shopify:section:load", wireHomeChatClearance);
  document.addEventListener("shopify:section:unload", function (event) {
    if (event.target.querySelector(".h25-hero__copy")) {
      if (homeChatObserver) homeChatObserver.disconnect();
      document.body.classList.remove("h25-buying-visible");
    }
  });

  // REQ-CHAT-LAUNCHER-1020-01: at 989px and below, tuck the Inbox launcher
  // while scrolling down and bring it back once scrolling stops, on scroll up
  // or at the page bottom, unless something tappable sits under it. The
  // launcher lives two shadow roots deep; if it can't be read, do nothing.
  function wireChatLauncherTuck() {
    var narrow = window.matchMedia("(max-width: 989px)");
    var tappable = "a[href], button, input, select, textarea, summary, label, [role='button'], [role='link'], [tabindex]:not([tabindex='-1'])";
    var lastY = window.scrollY;
    var idleTimer;
    function activator() {
      var host = document.querySelector("shopify-chat");
      var runtime = host && host.shadowRoot && host.shadowRoot.querySelector("shopify-agent-runtime");
      return runtime && runtime.shadowRoot && runtime.shadowRoot.querySelector("[part~='activator']");
    }
    function isOpen(btn) { return !!btn && btn.getAttribute("aria-expanded") === "true"; }
    function setTucked(on) { document.body.classList.toggle("ocu-chat-tucked", on); }
    // Tucking only changes opacity/visibility, so the rect is the launcher's
    // shown position either way. Sample a 3x3 grid across it.
    var samples = [0.1, 0.5, 0.9].reduce(function (all, x) { return all.concat([[x, 0.1], [x, 0.5], [x, 0.9]]); }, []);
    function coversTappable(btn) {
      var r = btn.getBoundingClientRect();
      if (!r.width) return false;
      return samples.some(function (p) {
        var under = document.elementsFromPoint(r.left + r.width * p[0], r.top + r.height * p[1]).filter(function (el) {
          return !el.closest("shopify-chat");
        })[0];
        return !!(under && under.closest(tappable));
      });
    }
    function settle() {
      var btn = activator();
      if (!narrow.matches || !btn || isOpen(btn)) return setTucked(false);
      setTucked(coversTappable(btn));
    }
    window.addEventListener("scroll", function () {
      if (!narrow.matches) return;
      var y = window.scrollY;
      var atBottom = window.innerHeight + y >= document.documentElement.scrollHeight - 4;
      if (y > lastY + 4 && !atBottom && !isOpen(activator())) setTucked(true);
      else if (y < lastY - 4 || atBottom) settle();
      lastY = y;
      clearTimeout(idleTimer);
      idleTimer = setTimeout(settle, 400);
    }, { passive: true });
    window.addEventListener("resize", settle);
    narrow.addEventListener("change", settle);
    // Inbox mounts late; settle once its launcher exists (bounded, like above).
    var tries = 0;
    (function waitForLauncher() {
      if (activator()) return settle();
      if (++tries < 30) setTimeout(waitForLauncher, 500);
    })();
  }

  function init() { wireMenu(); wireChatClearance(); wireHomeChatClearance(); wireChatLauncherTuck(); }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
